export default __webpack_public_path__ + "static/media/FlyingEagle201460s.1ed92986.mp3";